import { useCallback, useState } from 'react';
import type { ScheduleDayProps } from './types';
import { useStorageState } from 'hooks/use-storage-state';
import * as z from 'zod';
import Schedule from './Schedule';

interface Props {
  days: Array<ScheduleDayProps>;
  pixels_per_hour?: number;
  show_day_labels?: boolean;
}

const ScheduleApp = (props: Props): React.ReactElement => {
  const { days, pixels_per_hour = 120, show_day_labels = true } = props;

  const currentDay = new Date().toISOString().split('T')[0];
  const [hiddenDays, setHiddenDays] = useStorageState(
    `expanded-schedule-days-${currentDay}`,
    sessionStorage,
    z.array(z.string()),
    () => calculateHiddenDays(days),
  );
  const handleToggleDayVisibility = useCallback(
    (date: string) => {
      setHiddenDays(hiddenDays =>
        hiddenDays.includes(date)
          ? hiddenDays.filter(hiddenDay => hiddenDay !== date)
          : [...hiddenDays, date],
      );
    },
    [setHiddenDays],
  );

  return (
    <Schedule
      days={days}
      pixels_per_hour={pixels_per_hour}
      show_day_labels={show_day_labels}
      hiddenDays={hiddenDays}
      onToggleDayVisibility={handleToggleDayVisibility}
    />
  );
};

export default ScheduleApp;

const calculateHiddenDays = (days: Array<ScheduleDayProps>) => {
  return days.flatMap(day => {
    const today = new Date();
    // const today = new Date('2025-02-22T06:00:00Z');
    const daysSinceDate =
      (today.getTime() - new Date(day.date).getTime()) / (1000 * 60 * 60 * 24);
    const isInPast = daysSinceDate > 1 + 4 / 24;
    return isInPast ? [day.date] : [];
  });
};
